import React, { useState, FC } from 'react';

import {
  TableContainer, Table, TableHead, TableRow, TableCell,
  TableBody, makeStyles, Button, Select, MenuItem,
} from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface CatalogGeneratorProps {
  catalogSpecs: any[],
  pricesheets: any[],
  onGenerate: (catalogSpecId: string, pricesheetId: string) => void,
}

const CatalogGenerator: FC<CatalogGeneratorProps> = (props) => {
  const classes = useStyles();
  const [pricesheetId, setPricesheetId] = useState('');
  const [catalogSpecId, setCatalogSpecId] = useState('');
  const { catalogSpecs, pricesheets, onGenerate } = props;

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Catalog</TableCell>
            <TableCell>Pricesheet</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Select
                labelId="catalogspec"
                id="catalogspec"
                value={catalogSpecId}
                onChange={(event) => setCatalogSpecId(event.target.value as string)}
              >
                { catalogSpecs?.map((cs: any, index: number) => (
                  <MenuItem key={`${index + 1}`} value={cs.id}>{cs.name}</MenuItem>)) }
              </Select>
            </TableCell>
            <TableCell>
              <Select
                labelId="pricesheets"
                id="pricesheets"
                value={pricesheetId}
                onChange={(event) => setPricesheetId(event.target.value as string)}
              >
                { pricesheets?.map((ps: any, index2: number) => (
                  <MenuItem key={`${index2 + 1}`} value={ps.id}>{ps.label}</MenuItem>)) }
              </Select>
            </TableCell>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                onClick={() => {
                  onGenerate(catalogSpecId, pricesheetId);
                }}
              >
                Generate
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CatalogGenerator;
